import React, { useEffect, useState } from 'react';
import { Image, Rect, Group, Transformer } from 'react-konva';

export interface BoardImageProps {
  id: string;
  url: string;
  x: number;
  y: number;
  width: number;
  height: number;
  isSelected?: boolean;
  onMove: (id: string, x: number, y: number) => void;
  onSelect?: (id: string) => void;
  onResize?: (id: string, width: number, height: number) => void;
}

const KonvaBoardImage: React.FC<BoardImageProps> = ({ id, url, x, y, width, height, isSelected, onMove, onSelect, onResize }) => {
  const [imageObj, setImageObj] = useState<HTMLImageElement | null>(null);
  const groupRef = React.useRef<any>(null);
  const trRef = React.useRef<any>(null);

  useEffect(() => {
    const img = new window.Image();
    img.src = url;
    img.onload = () => setImageObj(img);
  }, [url]);

  React.useEffect(()=>{
    if(isSelected && trRef.current){
      trRef.current.nodes([groupRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  },[isSelected]);

  const handleTransformEnd=()=>{
    const node = groupRef.current;
    const imgNode = node.findOne('Image');
    const newW = Math.max(40, imgNode.width()*node.scaleX());
    const newH = Math.max(40, imgNode.height()*node.scaleY());
    // update image frame immediately
    imgNode.width(newW);
    imgNode.height(newH);
    node.findOne('Rect').width(newW);
    node.findOne('Rect').height(newH);
    node.scale({x:1,y:1});
    onResize && onResize(id,newW,newH);
  };

  if (!imageObj) return null;

  return (
    <>
    <Group
      x={x}
      y={y}
      draggable
      onDragEnd={(e)=>onMove(id, e.target.x(), e.target.y())}
      onClick={()=>onSelect && onSelect(id)}
      ref={groupRef}
      onTransformEnd={handleTransformEnd}
    >
      <Image image={imageObj} width={width} height={height} />
      {isSelected && <Rect width={width} height={height} stroke="#3b82f6" strokeWidth={2} />}
    </Group>
    {isSelected && <Transformer ref={trRef} boundBoxFunc={(oldB,newB)=>{ if(newB.width<20||newB.height<20) return oldB; return newB; }} />}
    </>
  );
};

export default KonvaBoardImage; 